// extracted by mini-css-extract-plugin
export default {"container":"OrdersApproval_container__Riv6u","wrapper":"OrdersApproval_wrapper__ciru9","empty":"OrdersApproval_empty__FnsOD"};